<script>
    import { user_info } from "../util/stores";

    let show_menu = false;
    let toggle_menu = () => {show_menu = !show_menu}

    $: user_avatar = $user_info.auth
        ? $user_info.data
            ? `https://mc-heads.net/avatar/${$user_info.data.mc_uuid}/32`
            : `https://cdn.discordapp.com/avatars/${$user_info.auth.id}/${$user_info.auth.avatar}.png`
        : undefined;
</script>

<div class="nav">
    <div class="wrapper">
        <div class="divider">
            <ul>
                <li><a href="/"><span class="logo">gitsmok<span class="super">web</span></span></a></li>
                <li><a href="/playerlist"><span class="nav-btn">Playerlist</span></a></li>
            </ul>
            <ul>
                <li><a href="/donate"><span class="nav-btn">Donate</span></a></li>
                {#if $user_info.data && $user_info.data.donor}
                <li><a href="/invite"><span class="nav-btn hot">Invite someone!</span></a></li>
                {:else}
                <li><a href="/whitelist"><span class="nav-btn">Get Whitelisted</span></a></li>
                {/if}

                {#if $user_info.auth}
                <li class="user-section">
                    <div class="username">
                        <span>{$user_info.data ? $user_info.data.mc_name : $user_info.auth.global_name}</span>
                        <span class="sub">{$user_info.auth.username}</span>
                    </div>
                    <button on:click={toggle_menu}><img src="{user_avatar}" alt="profile"></button>
                    {#if show_menu}
                    <div class="user-menu">
                        <ul>
                            <span class="user-menu-title">{$user_info.auth.global_name}</span>
                            <hr>
                            <li><a href="/whitelist"><span>Whitelist status</span></a></li>
                            <li><a href="/logout" tinro-ignore><span>Log Out</span></a></li>
                        </ul>
                    </div>
                    {/if}
                </li>
                {:else}
                    <li><a href="/login" class="nav-btn" tinro-ignore>Log In</a></li>
                {/if}
            </ul>
        </div>
    </div>
</div>

<style>
    /* Navigation */

    ul li {
        display: inline-block;
        vertical-align: middle;
        line-height: 30px;
    }

    .nav {
        padding: 15px;
        /* background-color: #fff;
        border-bottom: 2px solid #cacaca; */
        color: #000;
    }

    .logo {
        font-size: 24px;
        margin-right: 20px;
        line-height: 0;
    }

    .logo:hover {
        opacity: .75;
    }

    .logo span.super {
        font-size: 12px;
    }

    /* Navigation buttons */

    .nav-btn {
        text-decoration: none;
        color: #000000;
        padding: 6px 15px;
        margin: 6px;
        border: none;
        border-radius: 5px;
    }

    .nav-btn:hover {
        background-color: #ffffff9a;
    }

    .hot {
        background-color: #ff622b !important;
        background-image: linear-gradient(45deg, red, transparent);
        transition: .1s;
        color: #ffffff !important;
    }

    .hot:hover {
        background-color: red !important;
    }

    /* User section */

    .user-section {
        display: inline-flex;
        position: relative;
    }

    .user-section button {
        border: none;
        background-color: initial;    
        cursor: pointer;
    }

    .user-section img {
        width: 32px;
        height: 32px;
        border-radius: 3px;
        margin-left: 10px;
    }

    .user-section .username span {
        display: block;
        line-height: 16px;
        text-align: right;
    }

    .user-section .username .sub {
        font-size: 12px;
        opacity: .75;
    }

    /* User menu */

    .user-menu {
        background-color: #fff;
        padding: 5px 10px;
        border-style: solid;
        border-color: #cacaca;
        border-width: 1px;
        border-radius: 3px;
        position: absolute;
        top: 35px;
        right: 0px;
        width: 120px;
        box-shadow: 0 0 10px 3px #0000001a;
        z-index: 10;
    }

    .user-menu ul {
        margin: 0;
    }

    .user-menu li span {
        display: block;
        color: #000;
        text-decoration: none;
        font-size: 14px;
    }
    
    .user-menu li:hover {
        opacity: .5;
    }

    .user-menu::before {
        content: "";
        position: absolute;
        width: 10px;
        height: 10px;
        transform: rotate(45deg);
        z-index: 100;
        background-color: #fff;
        border-top: 1px solid #cacaca;
        border-left: 1px solid #cacaca;
        top: -6px;
        right: 11px;
    }

    .user-menu-title {
        color: #000;
    }

    .user-menu hr {
        margin: 5px 0;
    }
</style>